import { PageHeader } from "@ant-design/pro-components";
import { CopyAllOutlined, Message } from "@mui/icons-material";
import { Alert, Button, Card, Form, Input, message, Select, Textarea } from "antd";
import { memo, useEffect, useState } from "react";
import api from "../../../api/api";
import styles from "./PredefinedSmsEdit.module.css";
import { Router, useRoutes } from "react-router-dom";
import { set } from "react-hook-form";

const PredefinedSmsEdit = () => {
  const [form] = Form.useForm();
  const [messageTextArea, setMessageTextArea] = useState("");
  const [id, setId] = useState(null);
  const [key, setKey] = useState("");

  const [result, setResult] = useState({
    message: "",
    type: "",
  });

  useEffect(() => {
    loadPredefinedDetails();
  }, []);

  const loadPredefinedDetails = () => {
    const id = document?.location?.pathname?.split("/").slice(-1)[0];
    setId(id);
    api.get("/smspredefined/details/" + id).then((res) => {
      const data = res.data.data;
      setKey(data.key);
      setMessageTextArea(data.text);
    });
  };

  const sendRequest = () => {
    setResult({ message: "", type: "" });
    api
      .post("/smspredefined/edit/" + id, { text: messageTextArea })
      .then((res) => {
        if (res.data?.status === "success") {
          setResult({
            message: "ویرایش با موفقیت انجام شد.",
            type: "success",
          });
        } else {
          setResult({
            message: "مشکلی در ویرایش پیش آمده است.",
            type: "error",
          });
        }
      })
      .catch((error) => {
        let messageText = error.response.data?.error?.message ?? "مشکلی در ویرایش پیش آمده است.";
        setResult({
          message: messageText,
          type: "error",
        });
      });
  };

  return (
    <div className={styles.CopyRoadmap}>
      <PageHeader title={"ویرایش قالب" + " " + key} avatar={{ icon: <Message />, size: "large", style: { paddingTop: "8px" } }} />

      <Card className={styles.Form}>
        <Form form={form} name="validateOnly" layout="vertical" autoComplete="off">
          <div className={styles.MessageTextareaContainer}>
            <label>متن پیام</label>
            <Input.TextArea name="message" value={messageTextArea} onChange={(e) => setMessageTextArea(e.target.value)} rows={5} />
          </div>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => {
                sendRequest();
              }}
            >
              ویرایش 
            </Button>
          </Form.Item>

          {result.message && <Alert message={result.message} type={result.type} />}
        </Form>
      </Card>
    </div>
  );
};

export default memo(PredefinedSmsEdit);
